module.exports = "<footer>\n  <div class=\"container\">\n    <div class=\"row copyright\">\n      <div class=\"col-md-6\">\n        <p>&copy; 2014-2017 Cat's Cookies | Farm Direct.  All rights reserved.</p>\n      </div>\n      <div class=\"col-md-6\">\n        <p style=\"float:right;\"><a href=\"http://www.farmdirectinc.com\">Site Designed by Farm Direct, Inc.</a></p>\n      </div>\n    </div>\n  </div>\n    \n    <!-- <div class=\"container\"> -->\n      \n\n    <!-- </div> -->\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main